import { useQuery } from '@tanstack/react-query';
import { ActionPlansService } from '@/infra/services/action-plans';
import { QUERY_KEYS } from '@/utils/query-keys';

interface UseGetActionPlansByReportParams {
	organization_id: string;
	company_id?: string;
	sector_id?: string;
	line_id?: string;
	workstation_id?: string;
	start_date?: string;
	end_date?: string;
	report_ids?: string[];
	report_type: string;
	data_extraction_id?: string;
}

const Service = ActionPlansService.getInstance();

export const useGetActionPlansByReport = (params: UseGetActionPlansByReportParams) => {
	return useQuery({
		queryKey: [QUERY_KEYS.GET_ACTION_PLANS_COUNT_BY_REPORT, params],
		queryFn: async () => Service.findAllByReportWithCount(params),
		enabled: !!params.organization_id && !!params.report_type
	});
};
